export default {
    namespaced: true,

    state: {
        progressing: false
    },

    mutations: {
        start(state) {
            state.progressing = true;
        },

        stop(state) {
            state.progressing = false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/progress.js